import AppLayout from '@/layout/AppLayout.vue'

const Mail = () => import('@/view/mail/Mail.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/mail',
        component: Mail,
        meta: { key: 'mail' },
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
